import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        ticketsStatusEnum: {
            opened: 'tickets non cloturés',
            closed: 'tickets cloturés'
        },
        creationDateTimeFormat: '[Création] ' + defaultTranslation.fr.dateFormat.default + ' ' + defaultTranslation.fr.timeFormat.long,
        searchStream: {
            xs: 'rechercher',
            sm: 'rechercher dans les tickets'
        },
        searchCity: {
            xs: 'ville',
            sm: 'rechercher votre ville'
        },
        searchCompany: {
            xs: 'entreprise',
            sm: 'rechercher votre entreprise'
        },
        searchAgency: {
            xs: 'portefeuille',
            sm: 'rechercher votre portefeuille'
        },
        searchPatrimony: {
            xs: 'patrimoine',
            sm: 'rechercher votre patrimoine'
        },
        searchCallPurpose: {
            xs: 'type d\'incident',
            sm: 'rechercher un type d\'incident'
        },
        searchProvider: 'rechercher un fournisseur',
        searchIncident: 'rechercher un type d\'incident',
        callPurposez: 'raison d\'appel',
        callPurposezz: 'incident',
        callPurpose: 'qualification',
        callPurposes: 'types d\'incidents',
        correctOtp: 'Corriger',
        callPurposeEnum: {
            alarm: 'Alarme',
            barrier: 'Barrieres levantes',
            boiler: 'Chaudiere',
            bucket: 'Assainissement',
            bugs: 'Insecte',
            climber: 'Cordiste',
            closedlock: 'Securite',
            door: 'Porte de hall',
            electricity: 'Electricite',
            elevator: 'Ascenseur',
            evacuate: 'Evacuation d\'un immeuble',
            explosion: 'Incendie ou explosion sur site',
            fence: 'Portail coulissant',
            flood: 'Innondation',
            gas: 'Stockage gaz',
            gasvent: 'Vmc gaz',
            heater: 'Chauffage',
            hotwater: 'Eau chaude',
            intercom: 'Interphone',
            intrusionalarm: 'Detection intrusion',
            keys: 'Serrurerie vitrerie menuiserie',
            litter: 'Vide ordure',
            masonry: 'Maconnerie',
            message: 'Message',
            monitoring: 'Loge telesurveille',
            onduty: 'Astreinte',
            openlock: 'Intrusion Gardiennage',
            parkingvent: 'ventilation parking',
            pipe: 'Debouchage',
            plumber: 'Plomberie',
            pressure: 'Surpresseur',
            pump: 'Relevage',
            relocate: 'Demande de relogement',
            rollerblind: 'Volet Roulant HNO',
            roof: 'Couverture Charpente',
            smokevent: 'Desenfumage',
            swimmingpool: 'Piscine',
            tap: 'Engorgement eaux usees',
            tv: 'Television',
            vent: 'Vmc',
            warning: 'Incident Grave',
            waterdrop: 'Fuite eau',
            window: 'Menuiserie vitrerie',
            wrench: 'Multi-technique'
        },
        searchSummary: 'synthèse de recherche',
        callerIdentity: 'identification appelant',
        contactToCallback: 'personne à rappeler',
        contactToCallbackSameAsCaller: 'la personne à rappeler est l\'appelant',
        interventionLocation: 'lieu d\'intervention',
        interventionMonitoring: 'suivi d\'intervention',
        interventionReport: 'rapport d\'intervention',
        interventionDetail: 'détail de l\'intervention',
        interventionFilled: 'renseigner l\'intervention',
        interventionTime: 'délai d\'intervention',
        interventionTimeText: 'Délai entre la prise en charge d\'une mission par un fournisseur et le début de son intervention[[{token}. Ce délai ne respecte pas les engagements.]]',
        interventionDuration: 'durée d\'intervention',
        interventionDurationText: 'Intervalle de temps entre le début et la fin de l\'intervention',
        interventionStartedDate: 'date d\'intervention',
        interventionScheduledDate: 'date d\'intervention prévue',
        repairTime: 'délai de réparation',
        repairTimeText: 'Délai entre la prise en charge d\'une mission par un fournisseur et la fin de son intervention[[{token}. Ce délai ne respecte pas les engagements.]]',
        callCenterResponseTime: 'délai de transmission',
        callCenterResponseTimeText: 'Intervalle entre la création du ticket et la prise en charge par le fournisseur',
        callCenterReactionTime: 'temps de réaction',
        callCenterReactionTimeText: 'Intervalle entre la réception de la demande et la première action de l\'opérateur visant à sa résolution',
        additionalData: 'informations complémentaires',
        interventionAcceptation: 'prise en charge',
        acceptIntervention: 'intervention acceptée',
        refuseIntervention: 'intervention refusée',
        changeRecourse: 'changer de recours',
        journalEvent: 'journal du ticket',
        journalEventEnum: {
            callEmittedTo: {
                phone: 'Appel sortant vers {called} sur {identifier}',
                fax: 'Fax envoyé vers {called} sur {identifier}',
                mail: 'Email envoyé à {called} ({identifier})',
                sms: 'Sms envoyé à {called} sur {identifier}'
            },
            callReceived: {
                phone: 'Appel reçu de {caller} ({identifier})',
                fax: 'Fax reçu de {caller} ({identifier})',
                mail: 'Email reçu de {caller} ({identifier})',
                sms: 'Sms reçu de {caller} ({identifier})'  
            },
            assigneeIdentified: {
                recourseChanged: 'Changement de recours vers {assignee}',
                initialIdentification: 'Le ticket est assigné à {assignee}'
            },
            instructionsForAssigneeDefined: 'une instruction a été définie pour {assignee}',
            documentAttached: 'Le document {fileName} a été attaché au ticket',
            sendingServiceOrderReported: 'OE {ref} envoyé le {sendingDate}',
            callAnsweredByProvider: '{assignee} a répondu à l\'appel',
            callNotAnsweredByProvider: '{assignee} ne répond pas à l\'appel',
            interventionRequested: 'Intervention transmise par {medium} à {assignee} sur {identifier}',
            interventionAccepted: 'Prise en charge par {assignee}',
            notificationForInterventionAcceptedRequested: 'l\'envoi d’un email, vers {email}, {otherRecipients} a été déclenché',
            interventionRefused: 'Intervention refusée par {assignee}',
            ticketReopened: 'Ticket Réouvert par l\'opérateur',
            logTrialAdded: '{trialLabel}',
            messageAdded: 'Message : {message}',
            ticketCancelled: 'Ticket annulé',
            arrivedOnSite: 'Arrivée de {assignee} sur site',
            goneFromSite: 'Départ de {assignee} du site',
            interventionScheduled: 'Intervention prévue le {date} entre {startTime} et {endTime}',
            interventionDeadlineDefined: 'Date butoir d\'intervention au {deadline}',
            interventionStarted: 'Intervention débuté par {assignee}',
            interventionFinished: 'Intervention terminée par {assignee}',
            formalNoticeForProviderReported: 'Fournisseur mis en demeure au {deadline}',
            ticketUpdated: 'Mise à jour du ticket par l\'opérateur',
            ticketClosed: 'Ticket clos[[ - nature de la panne : {brakeDownNature}]]',
            ticketArchived: 'Ticket archivé',
            permanentlyFixed: 'Réparation définitive[[ - nature de la panne : {brakeDownNature}]]',
            partiallyFixed: 'Réparation provisoire[[ - nature de la panne : {brakeDownNature}]]',
            ticketClosedImpossibleRepair: 'Réparation impossible[[ - nature de la panne : {brakeDownNature}]]',
            postponedFix: 'Réparation ajournée[[ - nature de la panne : {brakeDownNature}]]',
            closedBeyondCallCenterScope: 'Hors périmètre',
            closedAfterSeveralUnsuccessfulRecalls: 'Clôture suite à plusieurs relances infructueuses',
            ticketInformationsCorrected: 'Correction des informations du ticket.[[ description: {new_request}.]][[ instructions: {new_instructions}.]][[ rapport: {new_closingReport}.]]',
            ticketEventInformationsCorrected: 'Correction des informations d\'un évènement : {text}',
            missionFinished: 'Mission finie pour {companyName}',  
            openingTicketPurposeCorrected: 'Diagnostique corrigé : {otpLabel}',
            locationReferenceCorrected: 'Localisation corrigé',
            callerCorrected: 'Appelant corrigé',
            workflowAppliedToTicket: 'Workflow appliqué au ticket',
            ticketQualifiedByCriteria: 'Critères de qualification appliqués',
            contextualCommentDisplayedOnTicket: 'Commentaire contextuel affiché sur le ticket',
            accessRestrictedToTicket: 'Ticket à accès restreint'
        },
        stateEnum: {
            ticketOpened: 'ticket ouvert',
            assigneeIdentified: 'fournisseur identifié',
            interventionAccepted: 'pris en charge par le fournisseur',
            interventionStarted: 'intervention en cours',
            interventionFinished: 'intervention en cours',
            ticketClosed: 'ticket clos',
            ticketArchived: 'ticket archivé',
            ticketCancelled: 'Ticket annulé',
            permanentlyFixed: 'réparation définitive',
            partiallyFixed: 'réparation partielle',
            ticketClosedImpossibleRepair: 'réparation impossible',
            postponedFix: 'réparation ajournée',
            closedBeyondCallCenterScope: 'Hors périmètre',
            closedAfterSeveralUnsuccessfulRecalls: 'fermé après plusieurs appels infructueux'
        },
        newTicket: 'nouveau ticket',
        newTicketText: ['Des tickets similaires existent', 'Etes vous sûr de vouloir créer un nouveau ticket ?'],
        newTickets: 'tickets',
        existingTickets: 'tickets existants',
        openTicket: 'ouvrir le ticket',
        closeTicket: 'clôturer le ticket',
        closingReport: 'rapport de clôture',
        identifyAssignee: 'identifier l\'intervenant',
        patrimonyProviderContacts: 'Intervenants du client',
        patrimonyProviderContactsz: 'qualifiés',
        otherProviderContacts: 'Autres contacts',
        otherProviderContactsz: 'autres',
        activityProviderCompanies: 'Fournisseurs du centre d\'appel',
        periodTickets: 'tickets sur la periode',
        periodTicketsText: '{count} tickets ont été créés sur la période du {from} au {to}',
        lastWeek: 'semaine dernière',
        lastWeekTickets: 'tickets la semaine dernière',
        lastWeekTicketsText: '{count} tickets ont été créés au cours de la semaine dernière',
        thisMonth: 'mois actuel',
        thisMonthTickets: 'tickets ce mois-ci',
        thisMonthTicketsText: '{count} tickets ont été créés au cours de ce mois-ci',
        lastMonth: 'mois dernier',
        lastMonthTickets: 'tickets le mois dernier',
        lastMonthTicketsText: '{count} tickets ont été créés au cours du mois dernier',
        ticketsDistribution: 'répartition des tickets',
        ticketsCreationFrequency: 'fréquence de création de tickets',
        dailyCreatedTicketCount: 'nombre de tickets créés par jour',
        ticketsDashboardStatusEnum: {
            opened: 'non cloturés',
            closed: 'cloturés'
        },
        ticketsInterventionEnum: {
            with: 'pris en charge',
            without: 'non pris en charge'
        },
        agency: 'portefeuille',
        correctLocationReference: 'Corriger le lieu d\'intervention',
        correctCaller: 'Corriger l\'appelant',
        agencies: 'portefeuilles',
        byAgency: 'par portefeuille',
        assignee: 'intervenant',
        assigneeTypeEnum: {
            providerContact: 'Intervenant du client',
            providerCompany: 'Fournisseur externe',
            anonymous: 'Intervenant annonyme'
        },
        provider: 'intervenant',
        providers: 'fournisseurs',
        providersTop10: 'top 10 des fournisseurs',
        patrimony: 'patrimoine',
        patrimonies: 'patrimoines',
        patrimoniesTop10: 'top 10 des patrimoines',
        company: 'société',
        closingRate: 'taux de clôture',
        closingEvent: 'type de clôture',
        aboutClosingRate: 'Pour en savoir plus sur le taux de clôture de vos dossiers, contactez votre service clients',
        summary: 'synthèse',
        diagnostic: 'diagnostic',
        seekSupport: 'solliciter',
        supportUserEnum: {
            manager: 'manager',
            admin: 'admin',
            inspector: 'inspecteur',
            careTaker: 'gardien',
            administrator: 'gestionnaire'
        },
        request: 'description du problème',
        instructions: 'instruction interne non visible par les résidents',
        response: 'réponse à l\'appelant',
        addAddress: 'ajouter une adresse',
        addAddressCity: 'code postal, ville',
        addAddressStreet: 'numéro, adresse',
        cmdTypeEnum: {
            fixPermanently: 'réparation définitive',
            fixPartially: 'réparation provisoire',
            postponeFix: 'réparation ajournée',
            closeTicketImpossibleRepair: 'réparation impossible',
            closeBeyondCallCenterScope: 'hors périmètre',
            cancelTicket: 'annulation du ticket'
        },
        mediumTypeEnum: {
            phone: 'tél',
            fax: 'fax',
            mail: 'email'
        },
        mediumTypezEnum: {
            phone: 'téléphone',
            fax: 'fax',
            mail: 'email'
        },
        scheduleIntervention: 'Programmer l\'intervention',
        startInterventionDate: 'Début d\'intervention',
        finishInterventionDate: 'Fin d\'intervention',
        addMessage: 'Ajouter un message',
        percentage: 'pourcentage',
        exportTickets: 'Télécharger le rapport',
        exportXlsxTickets: 'Télécharger le rapport Excel',
        exportPdfTickets: 'Télécharger le rapport PDF',
        exportingTickets: 'Téléchargement en cours',
        ticketExportEnum: {
            exportXlsx: 'Export excel',
            exportPdf: 'Liasse de tickets',
            reportPdf: 'Rapport de gestion'
        },
        xlsxTicketSheet: 'Tickets',
        xlsxTicketSheetColumnEnum: {
            ref: 'numéro de ticket',
            created: 'date de création',
            agency: 'agence',
            callerName: 'appelant',
            callerPhone: 'téléphone',
            callerEmail: 'email',
            request: 'description',
            callPurpose: 'type d\'incident',
            assigneeName: 'intervenant',
            assigneePhone: 'tel intervenant',
            assigneeType: 'type d\'intervenant',
            serviceOrderRef: 'n° OE',
            serviceOrderSendingDate: 'date d\'envoi de l\'OE',
            interventionScheduledStartDate: 'rendez-vous (au plus tôt)',
            interventionScheduledEndDate: 'rendez-vous (au plus tard)',
            interventionDeadline: 'date butoir',
            formalNoticeDate: 'date MED',
            formalNoticeDeadline: 'date butoir MED',
            addressStreet: 'adresse',
            addressZipCode: 'code postal',
            addressCity: 'ville',
            addressFloor: 'étage',
            addressUnit: 'numéro d\'appartement',
            addressEntrance: 'entrée',
            addressElevator: 'ascenseur',
            addressStaircase: 'escalier',
            addressBuilding: 'bâtiment',
            addressComplement: 'complément d\'adresse',
            missionFinished: 'mission terminée',
            freeComments: 'commentaires',
            status: 'statut',
            state: 'etat'
        },
        xlsxAgencySheet: 'Répartition par agence',
        xlsxAgencySheetColumnEnum: {
            label: 'agence',
            count: 'nombre de tickets'
        },
        xlsxCallPurposeSheet: 'Répartition par type d\'incident',
        xlsxCallPurposeSheetColumnEnum: {
            value: 'type d\'incident',
            count: 'nombre de tickets'
        },
        xlsxProviderSheet: 'Répartition par fournisseur',
        xlsxProviderSheetColumnEnum: {
            label: 'fournisseurs',
            count: 'nombre de tickets'
        },
        pdfExportPageEnum: {
            journal: 'journal'
        },
        pdfReportPageEnum: {
            agency: 'portefeuilles',
            patrimony: 'patrimoines',
            provider: 'fournisseurs'
        },
        pdfStatusEnum: {
            closed: 'tx clôture'
        },
        pdfInterventionEnum: {
            with: '   tx   P.E.C'
        },
        pdfPatrimonyTable: 'top 10 des patrimoines les plus consommateurs',
        pdfPatrimonyTableColumnEnum: {
            label: 'patrimonies',
            count: 'tickets',
            percentage: 'en %',
            closingRate: 'tx clôture',
            interventionRate: 'tx P.E.C.'
        },
        pdfPatrimonyChart: 'comparatif avec la période précédente',
        pdfProviderTable: 'top 10 des fournisseurs les plus actifs',
        pdfProviderTableColumnEnum: {
            label: 'fournisseurs',
            count: 'tickets',
            percentage: 'en %',
            closingRate: 'tx clôture',
            interventionRate: 'tx P.E.C.'
        },
        pdfProviderChart: 'fiabilité des fournisseurs',
        pdfProviderChartAxisEnum: {
            x: 'taux de réparation définitive',
            y: 'délai de prise en charge'
        },
        pdfAgencyTable: 'top 10 des portefeuilles les plus consommateurs',
        pdfAgencyTableColumnEnum: {
            label: 'portefeuilles',
            count: 'tickets',
            percentage: 'en %',
            closingRate: 'tx clôture',
            interventionRate: 'tx P.E.C.'
        },
        pdfAgencyChart: 'performance de gestion des demandes',
        pdfCallPurposeTable: 'répartition des types de demande',
        pdfCallPurposeTableColumnEnum: {
            label: 'types de demandes',
            count: 'tickets',
            percentage: 'en %',
            closingRate: 'tx clôture',
            interventionRate: 'tx P.E.C.'
        },
        pdfTicketOpened: 'tickets ouverts',
        pdfTicketClosed: 'tickets clôturés',
        pdfWithIntervention: 'pris en charge',
        pdfWithoutIntervention: 'non pris en charge',
        pdfWithInterventionIndex: 'P.E.C. : prise en charge',
        pdfPreviousPeriodIndex: 'Barre claire : période précédente',
        reportSendingServiceOrder: 'envoyer un OE',
        serviceOrder: 'OE {ref} envoyé le {sendingDate}',
        serviceOrderRef: 'n° OE',
        serviceOrderDate: 'date d\'envoi de l\'OE',
        defineInterventionDeadline: 'définir une date butoir',
        reportFormalNoticeForProvider: 'mettre en demeure l\'intervenant',
        correctTicketInformations: 'corriger le ticket',
        correctTicketEventInformations: 'corriger',
        receiveCallz: 'recevoir un appel',
        receiveCallzAction: 'interaction entrante',
        receiveCallzEnum: {
            receiveCall: 'autre',
            receiveCallFromAssignee: 'intervenant',
            receiveCallFromCaller: 'appelant',
            receiveCallFromContactToCallback: 'personne à rappeler'
        },
        receiveCallEnum: {
            receiveCall: 'appel reçu',
            receiveCallFromAssignee: 'appel reçu de l\'intervenant',
            receiveCallFromCaller: 'appel reçu de l\'appelant',
            receiveCallFromContactToCallback: 'appel reçu de la personne à rappeler'
        },
        emitCallz: 'émettre un appel',
        emitCallzAction: 'interaction sortante',
        emitCallzEnum: {
            emitCall: 'autre',
            emitCallToAssignee: 'intervenant',
            emitCallToCaller: 'appelant',
            emitCallToContactToCallback: 'personne à rappeler'
        },
        emitCallEnum: {
            emitCall: 'appel émis',
            emitCallToAssignee: 'appel émis vers l\'intervenant',
            emitCallToCaller: 'appel émis vers l\'appelant',
            emitCallToContactToCallback: 'appel émis vers la personne à rappeler'
        },
        updateTicket: 'actions',
        caller: 'appelant',
        recipientSupplementEnum: {
            floor: 'étage',
            unit: 'numéro d\'appartement',
            entrance: 'entrée',
            elevator: 'ascenseur',
            staircase: 'escalier',
        },
        geographicalSupplementEnum: {
            building: 'bâtiment',
        },
        pickCompany: 'choisir une entreprise',
        nameType: 'type de contact',
        nameTypeEnum: {
            civilName: 'individu',
            poorName: 'service'
        },
        gender: 'civilité',
        genderEnum: {
            male: 'M.',
            female: 'Mme.'
        },
        contactDetails: 'contexte de l\'appel',
        contactDetailsText: 'Merci de renseigner un moyen de contact',
        maxTicketPdfExportSizeExceeded: 'L\'export PDF est limité à 350 tickets',
        managementReport: 'de gestion',
        managementReportPeriod: 'pour la période du {from} au {to}',
        reportPdfInfo: 'Une période par défaut d\'un an est sélectionnée pour l\'export du rapport de gestion',
        openingTicketInstruction: 'instruction',
        acknowledgeInstruction: 'j\'ai pris connaissance de l\'instruction',
        emitCallHintEnum: {
            assigneeInterventionTransfer: 'Transmission de l\'intervention',
            assigneeIncidentAggravation: 'Agravation de l\'incident',
            assigneeRemindIntervention: 'Relancer d\'intervention',
            assigneeOther: 'Autre',
            callerIncidentAggravation: 'Agravation de l\'incident',
            callerAcceptIntervention: 'Prise en charge de l\'intervention',
            callerComplementaryInformation: 'Informations complémentaires',
            callerContactWithCompany: 'Prise de contact de l\'entreprise',
            callerSatisfaction: 'Contact satisfaction',
            callerOther: 'Autre'
        },
        emitCallCommentEnum: {
            assigneeIncidentAggravation: 'Nous avons contacté {name} au {phone} pour lui indiquer que l\'incident s\'est agravé. Précisions : ',
            assigneeRemindIntervention: 'Nous avons contacté {name} au {phone} pour relancer l\'intervention. Précisions : ',
            assigneeOther: 'Nous avons contacté {name} au {phone} pour : ',
            callerIncidentAggravation: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour lui demander si l\'incident ne s\'était pas agravé. Précisions : ',
            callerAcceptIntervention: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour l\'informer que l\'intervention est prise en charge. Précisions : ',
            callerComplementaryInformation: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour avoir des informations complémentaires sur l\'intervention. Précisions : ',
            callerContactWithCompany: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour lui demander si l\'entreprise l\'a bien contactée. Précisions : ',
            callerSatisfaction: 'Nous avons contacté [[{firstName} {lastName}]]{value} au Téléphone pour connaitre sa satisfaction',
            callerOther: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour : '
        },
        receiveCallHintEnum: {
            assigneeComplementaryInformation: 'Infos complémentaires',
            assigneeInterventionAdditionalContactInformation: 'Précisions sur les coordonnées de l\'intervention',
            assigneeInterventionCancellation: 'Annulation de l\'intervention',
            assigneeInterventionAcceptation: 'Acceptation de l\'intervention',
            assigneeImpossibleAccess: 'Accès impossible',
            assigneeScheduleIntervention: 'Programmation de l\'intervention',
            assigneeOther: 'Autre',
            callerIncidentAggravation: 'Agravation de l\'incident',
            callerProviderPassed: 'Information passage du technicien',
            callerComplementaryInformation: 'Informations complémentaires',
            callerIncidentAccess: 'Infos d\'accès à l\'incident',
            callerOther: 'Autre'
        },
        receiveCallCommentEnum: {
            assigneeComplementaryInformation: '{name} nous a contacté pour avoir des informations complémentaires. Précisions : ',
            assigneeInterventionAdditionalContactInformation: '{name} nous a contacté pour demander des précisions sur les coordonnées de l\'intervention. Précisions : ',
            assigneeInterventionCancellation: '{name} nous a contacté pour nous dire qu\'il n\'interviendra pas. Précisions : Intervention acceptée par l\'intervenant/ intervention refusée / A préciser dans le commentaire',
            assigneeInterventionAcceptation: '{name} nous a contacté pour nous dire qu\'il interviendra. A préciser dans le commentaire',
            assigneeImpossibleAccess: '{name} nous a contacté pour nous dire qu\'il n\'a pas accès à l\'instalation. A préciser dans le commentaire',
            assigneeScheduleIntervention: '{name} nous a contacté pour nous dire qu\'il programme l\'intervention. Précisions : Intervention acceptée par l\'intervenant/ intervention refusée / A préciser dans le commentaire',
            assigneeOther: '{name} nous a contacté pour : ',
            callerIncidentAggravation: '{name} nous a contacté pour  nous dire que l\'incident s\'était agravé. Précisions : ',
            callerProviderPassed: '{name} nous a contacté pour nous demander quant l\'entreprise allait passer. Précisions : ',
            callerComplementaryInformation: '{name} nous a contacté pour  avoir des informations complémentaires. Précisions : ',
            callerIncidentAccess: '{name} nous a contacté pour nous donner des informations complémentaires pour accéder à l\'incident. Précisions : ',
            callerOther: '{name} nous a contacté pour : '
        },
        openTicketLocationHintEnum: {
            unknownArea: 'Cet incident a été détecté comme étant impossible à localiser précisément',
            commomArea: 'Cet incident a été détecté comme étant situé dans les parties communes',
            privateAreaExtending: 'Cet incident a été détecté comme étant situé exclusivement dans les parties privatives mais pouvant atteindre les parties communes',
            privateArea: 'Cet incident a été détecté comme étant situé exclusivement dans les parties privatives',
            otherArea: 'Autre'
        },
        openTicketSeverityHintEnum: {
            unknownSeverity: 'Nous attendons des informations complémentaires sur la gravité de la demande',
            urgentSeverity: 'Cet incident a été détecté comme urgent',
            notUrgentSeverityExtending: 'Cet incident a été détecté comme pouvant devenir rapidement urgent',
            notUrgentSeverity: 'Cet incident a été détecté comme non urgent'
        },
        openTicketResponseEnum: {
            unknownAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
            commomAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
            privateAreaExtendingUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
            privateAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
            unknownAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            commomAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            privateAreaExtendingUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            privateAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            unknownAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            commomAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            privateAreaExtendingNotUrgentSeverityExtending: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes, nous vous conseillons d\'attendre des horaires de jour pour appeler un professionnel. Nous transmettons notre conversation à votre gestionnaire',
            privateAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
            unknownAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire',
            commomAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident n\'a pas de caractère d\'urgence. Nous transmettons la demande à votre gestionnaire',
            privateAreaExtendingNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire',
            privateAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire',
        },
        phonePlaceholder: '#Téléphone',
        namePlaceholder: '#Nom',
        incidentLocation: 'Situation',
        incidentSeverity: 'Gravité',
        incidentResponse: 'Réponse à l\'appelant',
        noTicketInfo: 'aucune information n\'est disponible',
        satisfaction: 'satisfaction',
        openTicketSteps: {
            identify: 'identification',
            contactToCallback: 'contact',
            request: 'diagnostic',
            response: 'réponse'
        },
        callbackContact: 'rappeler {name}',
        interventionCmdTypeEnum: {
            'acceptIntervention': 'Accepte l\'intervention',
            'refuseIntervention': 'Refuse l\'intervention'
        },
        requestInterventionAcceptedNotificationCmdTypeEnum: {
            'sendNotif': 'Confirmer l\'email {email} pour envoi du bon d\'intervention',
            'doNotSendNotif': 'Ne pas envoyer de bon d\'intervention'
        },
        finishMission: 'finir la mission',
        finishMissionHintEnum: {
            'scheduleInterventionManager': 'Intervention a planifier en heure ouvrée suivant le choix du gestionnaire',
            'interventionPostponed': 'Intervention différée en heure ouvrée grâce aux conseil du téléconseiller',
            'scheduleInterventionSelf': 'Intervention a planifier en heure ouvrée : à vérifier par vos soins',
            'interventionPaused': 'Intervention en standby a traiter en journée',
            'interventionImpossible': 'Intervention impossible, aucun prestataire de référencé',
            'interventionInProgress': 'Intervention en cours, vérifiez la bonne exécution de la réparation',
            'interventionResolved': 'Incident solutionné grâce aux conseil du téléconseiller',
            'otherInterventiom': 'Incident divers à gérer en heure ouvrée'
        },
        finishedMissionEvent: 'a terminé sa mission',
        callerStatus: 'Statut de l\'appelant',
        callerStatuses: ['Gestionnaire', 'Membre conseil syndical', 'Président CS', 'Gardien', 'Locataire', 'Co-propriétaire'],
        restrictedAccess: 'Ticket à diffusion restreinte',
        interventionModalDetail: 'finalite de l\'appel',
        bonDintervention: 'bon d\'intervention',
    }
}












export default {
    ...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/ticket/i18n.js